
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M22 5a2 2 0 012 2v18a2 2 0 01-2 2H10a2 2 0 01-2-2V7a2 2 0 012-2h12zm0 1H10a1 1 0 00-.993.883L9 7v18a1 1 0 00.883.993L10 26h12a1 1 0 00.993-.883L23 25V7a1 1 0 00-.883-.993L22 6zm-6 5a6 6 0 110 12 6 6 0 010-12zm0 1a5 5 0 100 10 5 5 0 000-10zm0 1a4 4 0 110 8 4 4 0 010-8zm0 1a3 3 0 100 6 3 3 0 000-6zm-4-6a1 1 0 110 2 1 1 0 010-2zm3.25 0a.75.75 0 110 1.5.75.75 0 010-1.5zm2.5 0a.75.75 0 110 1.5.75.75 0 010-1.5zm2.5 0a.75.75 0 110 1.5.75.75 0 010-1.5z"}})])
          )
        }
      }
    